import { render, staticRenderFns } from "./app-detail-purchase-panel.vue?vue&type=template&id=c21d31e8&scoped=true&"
import script from "./app-detail-purchase-panel.vue?vue&type=script&lang=js&"
export * from "./app-detail-purchase-panel.vue?vue&type=script&lang=js&"
import style0 from "./app-detail-purchase-panel.vue?vue&type=style&index=0&id=c21d31e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21d31e8",
  null
  
)

export default component.exports